import { IApiClientResponse, TResponse } from 'models/apiClient';
import { apiClient } from 'utils/apiClient';
import { EActionTypes } from 'state/actions/account';
import { ApiEndpoints } from 'models/apiEndpoints';
import { handleRestApiException } from 'utils/handleRestApiException';
import { EAlertVariants } from 'components/atoms/Alert';
import { formatDateToRequest } from 'utils/date';
import {
  ICreateCommercialOrganisationBodyRequest,
  ICreateIndividualBodyRequest,
} from 'models/account';
import { AccountType } from 'constants/AccountType';
import { IAccountCreateFormValues } from 'models/form';
import { logOut } from './auth';

const createIndividualRequest = async (
  body: ICreateIndividualBodyRequest,
): Promise<IApiClientResponse> => {
  try {
    body.dateOfBirth = formatDateToRequest(body.dateOfBirth, true, false, true);
    await apiClient.post<TResponse<any>>(ApiEndpoints.CREATE_ACCOUNT(), body);
    return {
      success: true,
      data: null,
    };
  } catch (e: any) {
    return {
      success: false,
      data: e?.response?.data,
      responseError: handleRestApiException(e),
    };
  }
};
const createCommercialOrganisationRequest = async (
  body: ICreateCommercialOrganisationBodyRequest,
): Promise<IApiClientResponse> => {
  try {
    await apiClient.post<TResponse<any>>(ApiEndpoints.CREATE_ACCOUNT(), body);
    return {
      success: true,
      data: null,
    };
  } catch (e: any) {
    return {
      success: false,
      data: e?.response?.data,
      responseError: handleRestApiException(e),
    };
  }
};

export const createAccount = async (
  dispatch: any,
  body: IAccountCreateFormValues,
  successCallback: (data: boolean) => void,
): Promise<TResponse<any>> => {
  dispatch({
    type: EActionTypes.CREATE_ACCOUNT,
  });

  if (body.type === AccountType.individual && body.termsAndConditions) {
    delete body.termsAndConditions;
  }

  const res =
    body.type === AccountType.individual
      ? await createIndividualRequest(body as ICreateIndividualBodyRequest)
      : await createCommercialOrganisationRequest(
          body as ICreateCommercialOrganisationBodyRequest,
        );

  try {
    if (res.success) {
      dispatch({
        type: EActionTypes.CREATE_ACCOUNT_SUCCESS,
      });
      successCallback(res.success as boolean);
    } else {
      dispatch({
        type: EActionTypes.CREATE_ACCOUNT_FAILURE,
        payload: {
          createMessage: { text: res?.data.message, variant: EAlertVariants.error },
        },
      });
    }
  } catch (e) {
    console.error(e);
  }

  return null;
};

export const isAccountLoggedIn = async (dispatch: any): Promise<TResponse<any>> => {
  try {
    const res = await apiClient.get<TResponse<any>>(ApiEndpoints.IS_LOGGED_IN());
    if (res.status !== 200) logOut(dispatch, () => {});
  } catch (e) {
    logOut(dispatch, () => {});
  }
};

export const clearCreateErrors = async (dispatch: any) => {
  dispatch({
    type: EActionTypes.CLEAR_ACCOUNT_ERRORS,
  });
};
